import {FetchCAPIError} from '@github-ui/copilot-shared-ui/capi/fetch-capi'
import {sendEvent} from '@github-ui/hydro-analytics'

import type {NormalizedStatus} from '../types/connectors'

export type ConnectorActionSource = 'row' | 'dialog' | 'dialog_retry'

interface ConnectorResult {
  outcome: 'success' | 'failure' | 'unknown'
  reason:
    | 'connection_confirmed'
    | 'disconnection_confirmed'
    | 'request_failed'
    | 'consent_navigation_failed'
    | 'connection_unconfirmed'
    | 'tab_closed'
    | 'timeout'
    | 'catalog_refresh_failed'
    | 'catalog_refresh_timeout'
  connection_status?: NormalizedStatus
  error_category?: 'http' | 'network' | 'unexpected'
  http_status?: number
}

export function connectorErrorMetadata(error: unknown): Pick<ConnectorResult, 'error_category' | 'http_status'> {
  if (error instanceof FetchCAPIError) {
    return error.hasResponse ? {error_category: 'http', http_status: error.status} : {error_category: 'network'}
  }
  return {error_category: 'unexpected'}
}

export function startConnectorAttempt(
  action: 'connect' | 'disconnect',
  connector: string,
  source: ConnectorActionSource,
) {
  const id = crypto.randomUUID()
  const context = {connector, source, attempt_id: id}
  const startedAt = performance.now()
  let finished = false

  sendEvent(`copilot_connectors.${action}_click`, context)

  return {
    id,
    finish(result: ConnectorResult) {
      // Polling and the final consent-tab refresh can observe the same result.
      if (finished) return
      finished = true
      sendEvent(`copilot_connectors.${action}_result`, {
        ...context,
        ...result,
        duration_ms: Math.round(performance.now() - startedAt),
      })
    },
  }
}
